import { useRef } from "react";
import type { SkillKind } from "@tabbio/types";
import type { SkillBuilderDraft } from "./skill-builder-shared";
import { CreateSkillDialog } from "./CreateSkillDialog.web";
import { PortableSkillDialog } from "./PortableSkillDialog.web";

interface Props {
  skillId?: string;
  initialDraft?: SkillBuilderDraft;
  presetKind?: SkillKind;
  seedDescription?: string;
  /** Create passes the new skill id; an edit save passes nothing. */
  onDone: (createdSkillId?: string) => void;
  onCancel: () => void;
}

/** Web route twin of the native wizard, hosted by the shared WebDialog shell. */
export function SkillBuilderWizard({
  skillId,
  initialDraft,
  presetKind,
  seedDescription,
  onDone,
  onCancel,
}: Props) {
  const completedRef = useRef(false);

  // A portable skill is one page (icon, name, description, method, Arabic,
  // model); only CV skills need the stepped wizard.
  if (skillId && initialDraft && initialDraft.kind !== "cv_custom") {
    return (
      <PortableSkillDialog
        skillId={skillId}
        initialDraft={initialDraft}
        onDone={onDone}
        onCancel={onCancel}
      />
    );
  }

  return (
    <CreateSkillDialog
      skillId={skillId}
      initialDraft={initialDraft}
      presetKind={presetKind}
      seedDescription={seedDescription}
      onCreated={(createdSkillId) => {
        completedRef.current = true;
        onDone(createdSkillId);
      }}
      onClose={() => {
        if (!completedRef.current) onCancel();
      }}
    />
  );
}
